import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, withKeys as _withKeys, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  id: "treegrid-desc",
  class: "sr-only"
}
const _hoisted_2 = { "aria-describedby": "treegrid-desc" }
const _hoisted_3 = { class: "sr-only" }
const _hoisted_4 = { class: "header" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = ["id"]
const _hoisted_7 = ["src", "alt"]
const _hoisted_8 = ["src", "alt"]
const _hoisted_9 = { key: 1 }
const _hoisted_10 = ["src", "alt"]
const _hoisted_11 = ["src", "alt"]
const _hoisted_12 = ["id"]
const _hoisted_13 = ["src", "alt"]
const _hoisted_14 = {
  key: 1,
  class: "month-weekly"
}
const _hoisted_15 = { class: "year" }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { class: "month month-weekly" }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { class: "date-weekly" }
const _hoisted_20 = { class: "date-weekly" }
const _hoisted_21 = { class: "year" }
const _hoisted_22 = { key: 0 }
const _hoisted_23 = { class: "month" }
const _hoisted_24 = ["src", "alt"]
const _hoisted_25 = { key: 2 }
const _hoisted_26 = { key: 0 }
const _hoisted_27 = { colspan: "13" }
const _hoisted_28 = { class: "noData" }
const _hoisted_29 = { key: 1 }
const _hoisted_30 = { key: 0 }
const _hoisted_31 = {
  class: "noDataTd",
  colspan: "13"
}
const _hoisted_32 = { key: 2 }
const _hoisted_33 = { colspan: "13" }
const _hoisted_34 = { class: "noData" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoaderComponent = _resolveComponent("LoaderComponent")!
  const _component_TableRow = _resolveComponent("TableRow")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("p", _hoisted_1, _toDisplayString(_ctx.$t('preventif.suivi.description')), 1),
    _createElementVNode("table", _hoisted_2, [
      _createElementVNode("caption", _hoisted_3, _toDisplayString(_ctx.$t('preventif.suivi.title')), 1),
      _createElementVNode("thead", _hoisted_4, [
        (_ctx.gridHeader.length === 0)
          ? (_openBlock(), _createElementBlock("tr", _hoisted_5, [
              _cache[19] || (_cache[19] = _createElementVNode("th", { scope: "col" }, null, -1)),
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(12, (index) => {
                return _createElementVNode("th", {
                  scope: "col",
                  id: `th-month-${index}`,
                  class: _normalizeClass(`${index === 0 ? 'first-cell' : index === 8 ? 'last-cell' : ''}`),
                  key: index
                }, [
                  (index === 1)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (this.previous && this.previous(...args))),
                        onKeydown: [
                          _cache[1] || (_cache[1] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (this.previous && this.previous(...args)), ["prevent"]), ["enter"])),
                          _cache[2] || (_cache[2] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (this.previous && this.previous(...args)), ["prevent"]), ["space"]))
                        ],
                        tabindex: "0",
                        role: "button",
                        class: "chevron-left",
                        src: this.chevronLeft,
                        alt: _ctx.$t('alt.page.precedente')
                      }, null, 40, _hoisted_7))
                    : _createCommentVNode("", true),
                  (index === 12)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 1,
                        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (this.next && this.next(...args))),
                        onKeydown: [
                          _cache[4] || (_cache[4] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (this.next && this.next(...args)), ["prevent"]), ["enter"])),
                          _cache[5] || (_cache[5] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (this.next && this.next(...args)), ["prevent"]), ["space"]))
                        ],
                        tabindex: "0",
                        role: "button",
                        class: "chevron-right",
                        src: this.chevronRight,
                        alt: _ctx.$t('alt.page.suivante')
                      }, null, 40, _hoisted_8))
                    : _createCommentVNode("", true)
                ], 10, _hoisted_6)
              }), 64))
            ]))
          : (_openBlock(), _createElementBlock("tr", _hoisted_9, [
              _createElementVNode("th", {
                scope: "col",
                id: "th-expand-collapse",
                class: _normalizeClass(!_ctx.isWeek ? 'small-header': '')
              }, [
                _createElementVNode("span", null, [
                  _createElementVNode("img", {
                    onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (this.upAll && this.upAll(...args))),
                    onKeydown: [
                      _cache[7] || (_cache[7] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (this.upAll && this.upAll(...args)), ["prevent"]), ["enter"])),
                      _cache[8] || (_cache[8] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (this.upAll && this.upAll(...args)), ["prevent"]), ["space"]))
                    ],
                    tabindex: "0",
                    role: "button",
                    class: "upAll",
                    src: this.chevronUp,
                    alt: _ctx.$t('alt.deplier')
                  }, null, 40, _hoisted_10),
                  _createElementVNode("img", {
                    onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (this.downAll && this.downAll(...args))),
                    onKeydown: [
                      _cache[10] || (_cache[10] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (this.downAll && this.downAll(...args)), ["prevent"]), ["enter"])),
                      _cache[11] || (_cache[11] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (this.downAll && this.downAll(...args)), ["prevent"]), ["space"]))
                    ],
                    tabindex: "0",
                    role: "button",
                    class: "downAll",
                    src: this.chevronDown,
                    alt: _ctx.$t('alt.replier')
                  }, null, 40, _hoisted_11)
                ])
              ], 2),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.gridHeader, (headerItem, index) => {
                return (_openBlock(), _createElementBlock("th", {
                  scope: "col",
                  id: `th-period-${index}`,
                  class: _normalizeClass(`${!_ctx.isWeek ? 'text-center' : ''} ${
                        _ctx.dayjs(_ctx.dayjs().format('YYYY-MM-DD')).isBetween(
                            _ctx.dayjs(headerItem.dateDebut).subtract(1, 'd'),
                            _ctx.dayjs(headerItem.dateFin).add(1, 'd')
                        )
                            ? 'current-date'
                            : ''
                    } ${index === 0 ? 'first-cell' : index === _ctx.gridHeader.length - 1 ? 'last-cell' : ''}`),
                  key: headerItem
                }, [
                  (index === 0)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (this.previous && this.previous(...args))),
                        onKeydown: [
                          _cache[13] || (_cache[13] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (this.previous && this.previous(...args)), ["prevent"]), ["enter"])),
                          _cache[14] || (_cache[14] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (this.previous && this.previous(...args)), ["prevent"]), ["space"]))
                        ],
                        tabindex: "0",
                        role: "button",
                        class: "chevron-left",
                        src: this.chevronLeft,
                        alt: _ctx.$t('alt.page.precedente')
                      }, null, 40, _hoisted_13))
                    : _createCommentVNode("", true),
                  (_ctx.isWeek)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                        _createElementVNode("div", _hoisted_15, [
                          (
                                        index === 0 ||
                                        new Date(headerItem.dateDebut).getFullYear() !==
                                            new Date(_ctx.gridHeader[index - 1].dateDebut).getFullYear()
                                    )
                            ? (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(new Date(headerItem.dateDebut).getFullYear()), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_17, [
                          (
                                        index === 0 ||
                                        new Date(_ctx.gridHeader[index - 1].dateDebut).getMonth() !==
                                            new Date(headerItem.dateDebut).getMonth()
                                    )
                            ? (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(_ctx.$t(`month.${new Date(headerItem.dateDebut).getMonth()}`)), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_19, [
                          _createElementVNode("span", null, _toDisplayString(_ctx.$t('from.date')) + " " + _toDisplayString(new Date(headerItem.dateDebut).toLocaleDateString()), 1)
                        ]),
                        _createElementVNode("div", _hoisted_20, [
                          _createElementVNode("span", null, _toDisplayString(_ctx.$t('to.date')) + " " + _toDisplayString(new Date(headerItem.dateFin).toLocaleDateString()), 1)
                        ])
                      ]))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                        _createElementVNode("div", _hoisted_21, [
                          (index === 0 || new Date(headerItem.dateDebut).getMonth() === 0)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_22, _toDisplayString(new Date(headerItem.dateDebut).getFullYear()), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_23, [
                          _createElementVNode("span", null, _toDisplayString(_ctx.$t(`month.${new Date(headerItem.dateDebut).getMonth()}`)), 1)
                        ])
                      ], 64)),
                  (index === _ctx.gridHeader.length - 1)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 3,
                        onClick: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (this.next && this.next(...args))),
                        onKeydown: [
                          _cache[16] || (_cache[16] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (this.next && this.next(...args)), ["prevent"]), ["enter"])),
                          _cache[17] || (_cache[17] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (this.next && this.next(...args)), ["prevent"]), ["space"]))
                        ],
                        tabindex: "0",
                        role: "button",
                        class: "chevron-right",
                        src: this.chevronRight,
                        alt: _ctx.$t('alt.page.suivante')
                      }, null, 40, _hoisted_24))
                    : _createCommentVNode("", true)
                ], 10, _hoisted_12))
              }), 128))
            ])),
        (_ctx.gridHeader.length > 0)
          ? (_openBlock(), _createElementBlock("tr", _hoisted_25, [
              _cache[20] || (_cache[20] = _createElementVNode("th", { scope: "col" }, null, -1)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.gridHeader, (headerItem) => {
                return (_openBlock(), _createElementBlock("th", {
                  scope: "col",
                  key: headerItem
                }))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ]),
      (_ctx.isLoading)
        ? (_openBlock(), _createElementBlock("tbody", _hoisted_26, [
            _createElementVNode("tr", null, [
              _createElementVNode("td", _hoisted_27, [
                _createElementVNode("div", _hoisted_28, [
                  (_ctx.isLoading)
                    ? (_openBlock(), _createBlock(_component_LoaderComponent, {
                        key: 0,
                        class: "loader",
                        "aria-label": _ctx.$t('search.isLoading')
                      }, null, 8, ["aria-label"]))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ]))
        : (_ctx.gridHeaderAll.length > 0 && _ctx.gridData.length !== 0)
          ? (_openBlock(), _createElementBlock("tbody", _hoisted_29, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.gridData, (item, i) => {
                return (_openBlock(), _createBlock(_component_TableRow, {
                  rowData: item,
                  key: item.title,
                  rowClass: _ctx.RowClass.first,
                  openAll: _ctx.openAll,
                  selectionMode: _ctx.selectionMode,
                  "selected-report-ids": _ctx.selectedReportIds,
                  "selected-ui-ids": _ctx.selectedUiIds,
                  onEmitOpenModal: this.emitOpenModal,
                  onOpen: this.handleEvent,
                  onCellClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.$emit('cellClick', $event))),
                  index: i
                }, null, 8, ["rowData", "rowClass", "openAll", "selectionMode", "selected-report-ids", "selected-ui-ids", "onEmitOpenModal", "onOpen", "index"]))
              }), 128)),
              (_ctx.otherDataLoading)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_30, [
                    _createElementVNode("td", _hoisted_31, _toDisplayString(_ctx.$t('search.isLoading')), 1)
                  ]))
                : _createCommentVNode("", true)
            ]))
          : (_openBlock(), _createElementBlock("tbody", _hoisted_32, [
              _createElementVNode("tr", null, [
                _createElementVNode("td", _hoisted_33, [
                  _createElementVNode("div", _hoisted_34, _toDisplayString(_ctx.$t('preventif.no.data')), 1)
                ])
              ])
            ]))
    ])
  ], 64))
}